import { render, staticRenderFns } from "./UnidentifiedStockRequestView.vue?vue&type=template&id=0ef24dc0"
import script from "./UnidentifiedStockRequestView.vue?vue&type=script&lang=js"
export * from "./UnidentifiedStockRequestView.vue?vue&type=script&lang=js"
import style0 from "./UnidentifiedStockRequestView.vue?vue&type=style&index=0&id=0ef24dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports